<template>
<!-- Page Wrapper -->
<div id="wrapper">

    <div  id="accordionSidebar" class="navbar-nav sidebar sidebar-dark accordion"  style="border-right:1px solid #ccc;background:#333">
    <!-- Sidebar -->
    <ul>

        <!-- Sidebar - Brand -->
        <a class="sidebar-brand bg-primary d-flex align-items-center justify-content-center" href="/">
            <div class="sidebar-brand-text">Planet</div>
        </a>

        <!-- Nav Item - Dashboard -->
        <li class="nav-item">
            <router-link class="nav-link" to="/dashboard"><i class="fas fa-fw fa-tachometer-alt"></i><span>Dashboard</span></router-link>
        </li>
        <!-- Nav Item - Dashboard -->
        <li class="nav-item">
            <router-link class="nav-link" to="/completed"><i class="fas fa-fw fa-check-circle"></i><span>Complete Jobs</span></router-link>
        </li>

    </ul>
    <!-- Admin Nav -->
    <ul v-if="user && user.data && user.data.role > 8">
        <li class="nav-item">
            <router-link class="nav-link" to="/inward-goods"><i class="fas fa-fw fa-truck"></i><span>Inward Goods</span></router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/enquires"><i class="fas fa-fw fa-envelope"></i><span>All Enquiries</span></router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/archive"><i class="fas fa-fw fa-folder"></i><span>Job Archive</span></router-link>
        </li>
        <li v-if="user.data.role > 10" class="nav-item">
            <router-link class="nav-link" to="/users"><i class="fas fa-fw fa-user"></i><span>Admin Users</span></router-link>
        </li>
       <li v-if="user.data.role > 10" class="nav-item">
            <router-link class="nav-link" to="/organisations"><i class="fas fa-fw fa-users"></i><span>Organisations</span></router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/help"><i class="fas fa-fw fa-info-circle"></i><span>Help/Support</span></router-link>
        </li>
        <!--<li class="nav-item">
            <router-link class="nav-link" to="/full-search"><i class="fas fa-fw fa-search"></i><span>Full Search</span></router-link>
        </li>-->
        <!-- Divider -->

        <!-- Sidebar Toggler (Sidebar) 
      <div class="text-center d-none d-md-inline mt-4">
        <button class="rounded-circle border-0" id="sidebarToggle"></button>
      </div>-->

    </ul>
    <!-- End of Sidebar -->
    </div>

    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

            <!-- Topbar -->
            <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                <!-- Sidebar Toggle (Topbar) -->
                <button @onclick="!sidebarToggle" id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3">
                    <i class="fa fa-bars"></i>
                </button>

                <!-- Topbar Search -->
                <!-- <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
            <div class="input-group">
              <input type="text" class="form-control bg-light border-0 small" placeholder="Search by Job Id or Email" aria-label="Search" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button @click="searchJobs" class="btn btn-primary" type="button">
                  <i class="fas fa-search fa-sm"></i>
                </button>
              </div>
            </div>
          </form>-->

                <!-- Topbar Navbar -->
                <ul class="navbar-nav ml-auto">

                    <!-- Nav Item - Search Dropdown (Visible Only XS)
            <li class="nav-item dropdown no-arrow d-sm-none">
              <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-search fa-fw"></i>
              </a>-->
                    <!-- Dropdown - Messages
              <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
                <form class="form-inline mr-auto w-100 navbar-search">
                  <div class="input-group">
                    <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="button">
                        <i class="fas fa-search fa-sm"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </li>-->
    
                    <!-- Nav Item - Messages -->
                    <li class="nav-item mx-1" v-if="jobNotes.length">
                        <dropdown>

                            <template v-slot:header>
                                <i class="fas fa-comments fa-fw"></i>
                                <!-- Counter - Messages -->
                                <span class="badge badge-danger badge-counter">{{ jobNotes.length }}</span>
                            </template>
                            <div class="dropdown-list">
                                <h6 class="dropdown-header">
                                    Notes Not Seen 
                                </h6>
                                <div v-for="(note, index) in jobNotes" v-bind:key="index">
                                    <router-link v-if="note.jobid" :to="{ name: 'job-view', params: { id: $options.filters.jobid(note.jobid) } }" class="dropdown-item d-flex align-items-center" href="#" >
                                        <div class="dropdown-list-image mr-2 rounded-circle bg-success fancydate">
                                            <p v-html="$options.filters.fancyDate(note.submitted)"></p>
                                            <!--<div class="status-indicator bg-success"></div>-->
                                        </div>
                                        <div class="">
                                            <div class="text-truncate">{{note.message}}</div>
                                            <div class="small text-gray-600">Job# {{note.jobid | jobid}}</div>
                                        </div>
                                    </router-link>
                                    <router-link v-if="note.contactid" :to="{ name: 'enquiry-view', params: { id: note.contactid } }" class="dropdown-item d-flex align-items-center" href="#" >
                                        <div class="dropdown-list-image mr-2 rounded-circle bg-success fancydate">
                                            <p v-html="$options.filters.fancyDate(note.submitted)"></p>
                                            <!--<div class="status-indicator bg-success"></div>-->
                                        </div>
                                        <div class="">
                                            <div class="text-truncate">{{note.message}}</div>
                                            <div class="small text-gray-600">Enquiry# {{note.contactid}}</div>
                                        </div>
                                    </router-link>
                                </div>
                                <!--<a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="dropdown-list-image mr-3">
                    <img class="rounded-circle" src="https://source.unsplash.com/AU4VPcFN4LE/60x60" alt="">
                    <div class="status-indicator"></div>
                  </div>
                  <div>
                    <div class="text-truncate">I have the photos that you ordered last month, how would you like them sent to you?</div>
                    <div class="small text-gray-500">Jae Chun · 1d</div>
                  </div>
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="dropdown-list-image mr-3">
                    <img class="rounded-circle" src="https://source.unsplash.com/CS2uCrpNzJY/60x60" alt="">
                    <div class="status-indicator bg-warning"></div>
                  </div>
                  <div>
                    <div class="text-truncate">Last month's report looks great, I am very happy with the progress so far, keep up the good work!</div>
                    <div class="small text-gray-500">Morgan Alvarez · 2d</div>
                  </div>
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="dropdown-list-image mr-3">
                    <img class="rounded-circle" src="https://source.unsplash.com/Mv9hjnEUHR4/60x60" alt="">
                    <div class="status-indicator bg-success"></div>
                  </div>
                  <div>
                    <div class="text-truncate">Am I a good boy? The reason I ask is because someone told me that people say this to all dogs, even if they aren't good...</div>
                    <div class="small text-gray-500">Chicken the Dog · 2w</div>
                  </div>
                </a>-->
                               <!-- <router-link to="/enquires" class="dropdown-item text-center small text-gray-500" href="#">Read More Messages</router-link>-->
                            </div>
                        </dropdown>
                    </li>

                    <div v-if="jobNotes.length" class="topbar-divider d-none d-sm-block"></div>

                    <!-- Nav Item - User Information -->
                    <li class="nav-item no-arrow">
                        <dropdown v-if="user && user.data">

                            <template v-slot:header>
                                <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{user.data.name}}</span>
                                <span v-html="$options.filters.getCaps(user.data.name, user.auth.uid, users)"></span>
                            </template>
                            <!-- Dropdown - User Information -->

                            <router-link to="/profile" class="dropdown-item">
                                <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                Profile
                            </router-link>
                            <!--
                    <a class="dropdown-item" href="#">
                      <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                      Settings
                    </a>
                    <a class="dropdown-item" href="#">
                      <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                      Activity Log
                    </a>-->
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click="logout()" data-toggle="modal" data-target="#logoutModal">
                                <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                Logout
                            </a>

                        </dropdown>
                    </li>

                </ul>

            </nav>
            <!-- End of Topbar -->

            <!-- Begin Page Content -->
            <div class="container-fluid">

                <router-view />

            </div>
            <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <!-- Footer -->
        <footer class="sticky-footer bg-white">
            <div class="container my-auto">
                <div class="copyright text-center my-auto">
                    <span>Copyright &copy; {{new Date().getFullYear()}}</span>
                </div>
            </div>
        </footer>
        <!-- End of Footer -->

    </div>
    <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
// Get a RTDB instance
import {
    mapGetters
} from "vuex";
import {
    db,
    firebaseAuth
} from '../main'
import Dropdown from '../components/Dropdown.vue'

export default {
    name: 'Main',
    components: {
        Dropdown,
    },
    data() {
        return {
            profileDropdownToggle: false,
            messageDropdownToggle: false,
            contactsRaw: [],
            sidebarToggle: false,
            users: [],
            jobNotesRaw: []
        }
    },

    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        }),
        jobNotes: function () {
            var arr = [...this.jobNotesRaw].reverse();
            return arr.filter(arr => !arr.viewDate);
        }
    },
    mounted() {
        var t = this;
        console.log('created');
        t.$rtdbBind("jobNotesRaw", db.ref('jobNotes').orderByChild("viewForID").equalTo(t.user.auth.uid))
    },
    firebase: {
        //contactsRaw: db.ref('contactForm2020').orderByChild('contactid').limitToLast(5),
        //notesRaw: db.ref('jobNotes').orderByChild('submitted').limitToLast(5),
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
    methods: {
        profileDropdownToggleMethod(e) {
            e.stopPropagation() // this will stop propagation of this event to upper level
            this.profileDropdownToggle = !this.profileDropdownToggle

            if (this.profileDropdownToggle) {
                window.addEventListener('click', () => {
                    this.profileDropdownToggle = false
                })
            } else {
                window.removeEventListener('click', () => {
                    this.profileDropdownToggle = false
                })
            }

            console.log(e, this.profileDropdownToggle);
        },
        messagesDropdownToggleMethod(e) {

            e.stopPropagation() // this will stop propagation of this event to upper level
            this.messageDropdownToggle = !this.messageDropdownToggle

            if (this.messageDropdownToggle) {
                window.addEventListener('click', () => {
                    this.messageDropdownToggle = false
                })
            } else {
                window.removeEventListener('click', () => {
                    this.messageDropdownToggle = false
                })
            }
        },
        searchJobs() {

        },
        logout() {
            firebaseAuth().signOut().then(() => {
                this.$router.replace('/login')
            })
        }
    }
}
</script>

<style>
.fancydate {
    text-align: center;
    color: #fff;
    line-height: 1;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-transform: uppercase;
    font-size: .75rem;
}

.fancydate p {
    margin: 0;
}

.fancydate em {
    display: block;
    font-size: 1rem;
    font-style: normal;
    font-weight: bold;
}
</style>
